<template>
    <div>
        <div class="content">
            <p class="allcomment">全部评论</p>
            <el-divider></el-divider>
            <div v-for="item in commentlist" :key="item.index">
                <div class="commentcontent">
                    <img :src="item.avatar" class="avatar" />
                    <div class="rightcontent">
                        <div class="top">
                            <div class="uname">{{item.uname}}</div>
                            <div class="article" v-if="item.is_stay === 0" v-show="true">评论你的原创作品</div>
                            <div
                                class="articletitle"
                                v-if="item.is_stay === 0"
                                v-show="true"
                            >《{{item.title}}》</div>
                            <div class="article" v-if="item.is_stay === 1" v-show="true">回复了你</div>
                            <div
                                class="articletitle"
                                v-if="item.is_stay === 1"
                                v-show="true"
                            >“{{item.topmsg}}”</div>
                            <div class="time">{{item.create}}</div>
                        </div>
                        <div class="text">{{item.content}}</div>
                    </div>
                    <div class="callback" @click="goCommit(item)">回复</div>
                </div>
                <el-divider></el-divider>
            </div>
            <el-pagination
                background
                layout="jumper, prev, pager, next, slot, total"
                :total="total"
                :current-page="page"
                @current-change="currentChange"
                @prev-click="prevClick"
                @next-click="nextClick"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                commentlist: [],
                total: 0,
                page: 1
            };
        },
        mounted() {
            this.getcommentlist();
        },
        methods: {
            goCommit(item) {
                // 跳转详情页的评论位置
                this.$router.push({
                    name: 'article-details',
                    query: {
                        id: item.aid,
                        comment_id: item.firstid
                    }
                });
            },
            getcommentlist() {
                this.httpGet(this.$root.getallcomment, {
                    page: this.page
                })
                    .then(result => {
                        if (result.count) {
                            this.commentlist.push(...result.list);
                            this.total = Number(result.count);
                        } else {
                            this.commentlist = [];
                            this.total = 0;
                        }
                        console.log(result.list, 789);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            currentChange(page) {
                console.log('currentChange', page);
                this.page = page;
                this.commentlist = [];
                this.getcommentlist();
            },
            prevClick(page) {
                console.log('currentChange1', page);
                this.page = page;
                this.commentlist = [];
                this.getcommentlist();
            },
            nextClick(page) {
                console.log('currentChange2', page);
                this.page = page;
                this.commentlist = [];
                this.getcommentlist();
            }
        }
    };
</script>
<style lang="stylus"  rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .content {
        width: 832px;
        border-radius: 8px;
        background-color: white;
        padding: 24px;
        position: relative;

        .allcomment {
            font-size: 16px;
        }

        .commentcontent {
            flex-x(space-between, flex-start);
            width: 832px;

            .avatar {
                border-radius: 50px;
                width: 48px;
                height: 48px;
            }

            .rightcontent {
                display: flex;
                flex-direction: column;
                margin-left: 24px;
                width: 708px;

                .top {
                    flex-x(flex-start, flex-start);
                    max-height: 54px;
                    width: 100%;

                    .uname {
                        multi(3);
                        font-size: 16px;
                        line-height: 17px;
                        max-width: 110px;
                        max-height: 54px;
                        overflow: hidden;
                    }

                    .article {
                        font-size: 14px;
                        line-height: 19px;
                        opacity: 0.85;
                        margin-left: 8px;
                        max-width: 65px;
                    }

                    .articletitle {
                        multi(3);
                        margin-left: 8px;
                        font-size: 14px;
                        line-height: 17px;
                        color: #197DFF;
                        max-width: 400px;
                        max-height: 54px;
                        overflow: hidden;
                    }

                    .time {
                        margin-left: 8px;
                        font-size: 12px;
                        line-height: 16px;
                        opacity: 0.45;
                        max-width: 125px;
                    }
                }

                .text {
                    font-size: 14px;
                    opacity: 0.85;
                    width: 90%;
                    margin-top: 16px;
                }
            }

            .callback {
                width: 32px;
                height: 18px;
                font-size: 14px;
                opacity: 0.65;
                margin-left: 20px;
                cursor: pointer;
                float: right;
                // position absolute
                // right 24px
            }
        }
    }

    >>>.el-pagination {
        // width: 832px;
        flex-center();
        padding: 20px;
        background: white;
    }
</style>
